module.exports = __webpack_public_path__ + "static/img/15ok.5f5e99c0.webp";